module.exports = __webpack_public_path__ + "assets/img/gougou.1f7d15db.svg";